import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Form, Input, Button, Icon, Avatar, message } from 'antd';
import styled from 'styled-components';
import { request } from '~/components/Instance';

var Section = styled.div`
  margin-bottom: 32px;
  &:last-child { margin-bottom: 0; }
`;

var SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
`;

var SectionIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: ${function(p) { return p.bg || '#f0f5ff'; }};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  .anticon { font-size: 16px; color: ${function(p) { return p.color || '#1890ff'; }}; }
`;

var SectionTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #262626;
`;

var SectionDescription = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 1px;
`;

var FormCard = styled.div`
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 20px 24px;
  .ant-form-item { margin-bottom: 16px; }
  .ant-form-item:last-child { margin-bottom: 0; }
  .ant-form-item-label { line-height: 1.5; padding-bottom: 4px; }
  .ant-form-item-label label { font-size: 13px; font-weight: 500; color: #595959; }
  .ant-input { border-radius: 6px; height: 40px; font-size: 14px; }
`;

var FooterBar = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 1100px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 12px 24px;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  z-index: 1020;

  .ant-btn {
    height: 44px;
    font-size: 15px;
    padding: 0 32px;
    border-radius: 8px;
  }
`;

var ProfileHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  margin-bottom: 16px;
`;

var ProfileInfo = styled.div`
  flex: 1;
`;

var ProfileName = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #262626;
`;

var ProfileEmail = styled.div`
  font-size: 13px;
  color: #8c8c8c;
  margin-top: 2px;
`;


var SettingsBasicForm = function(props) {
  var form = props.form;
  var user = props.user;
  var updateUser = props.updateUser;
  var getFieldDecorator = form.getFieldDecorator;
  var savingState = useState(false);
  var isSaving = savingState[0];
  var setIsSaving = savingState[1];

  var initials = (user.name || '?').split(' ').map(function(n) { return n[0]; }).join('').substring(0, 2).toUpperCase();

  var handleSubmit = function(e) {
    e.preventDefault();
    form.validateFieldsAndScroll(function(err, values) {
      if (!err) {
        setIsSaving(true);
        request('patch', '/user', values).then(function() {
          updateUser({ name: values.fullname });
          message.success('Perfil atualizado com sucesso!');
        }).finally(function() {
          setIsSaving(false);
        });
      }
    });
  };

  return (
    <Form layout="vertical" onSubmit={handleSubmit}>
      <Section>
        <ProfileHeader>
          <Avatar size={56} style={{ backgroundColor: '#1890ff', fontSize: 20, fontWeight: 600 }}>
            {initials}
          </Avatar>
          <ProfileInfo>
            <ProfileName>{user.name || 'Usuário'}</ProfileName>
            <ProfileEmail>{user.email}</ProfileEmail>
          </ProfileInfo>
        </ProfileHeader>
      </Section>

      <Section>
        <FormCard>
          <Form.Item label="Email">
            <Input value={user.email} disabled prefix={<Icon type="mail" style={{ color: '#bfbfbf' }} />} />
          </Form.Item>
          <Form.Item label="Nome Completo">
            {getFieldDecorator('fullname', {
              initialValue: user.name,
              rules: [{ required: true, message: 'Por favor informe seu nome completo!' }],
            })(<Input placeholder="Seu nome completo" prefix={<Icon type="user" style={{ color: '#bfbfbf' }} />} />)}
          </Form.Item>
        </FormCard>
      </Section>
      <FooterBar>
        <Button type="primary" htmlType="submit" loading={isSaving} icon="save">
          Salvar
        </Button>
      </FooterBar>
    </Form>
  );
};

var mapStateToProps = function(state) {
  return { user: state.user };
};

var mapDispatchToProps = function(dispatch) {
  return {
    updateUser: function(data) { dispatch({ type: 'UPDATE_USER', payload: data }); }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(SettingsBasicForm));
